import React from 'react';
import { QuestionnaireTemplateStore } from '../../../store/questionnaireTemplateModel';
import { formElementSchema } from '../../schemas/formElement.schema';
import { QuestionSelectImage } from './QuestionSelectImage';

export const QuestionImageInput = React.memo(function QuestionImageInput({ id }: { id: string }) {
  const type = QuestionnaireTemplateStore.useStoreState((state) => state.getElementValue(id, 'questionType'));

  const withImage = formElementSchema[type]?.withImage ?? false;
  const images = QuestionnaireTemplateStore.useStoreState((state) => state.getElementValue(id, 'images'));
  const addImage = QuestionnaireTemplateStore.useStoreActions((state) => state.updateElementValue);

  if (!withImage) return null;
  return (
    <QuestionSelectImage
      elementId={id}
      questionType={type}
      images={images || []}
      onSelect={(values) => {
        addImage({ id, path: 'images', value: values });
      }}
    />
  );
});
